import React from "react";
import StatisticsCard from "../../common/StatisticsCard"; 

const KeyDisputeCards = ({ statistics = {} }) => {
  const formatNumber = (num) => (num ?? 0).toLocaleString();

  const stats = [
    {
      label: "Total Active Cases",
      value: formatNumber(statistics.active_cases),
      bgColor: "bg-blue-100",
      textColor: "text-blue-600",
      description: "Current open cases",
    },
    {
      label: "Pending Cases",
      value: formatNumber(statistics.pending_cases),
      bgColor: "bg-yellow-100",
      textColor: "text-yellow-600",
      description: "Awaiting action",
    },
    {
      label: "New Cases This Month",
      value: formatNumber(statistics.this_month?.new_cases),
      bgColor: "bg-indigo-100",
      textColor: "text-indigo-600",
      description: "This month's new cases",
    },
  ];

  return (
    <StatisticsCard
      stats={stats}
      columns="xl:grid-cols-3"
      text="text-xs"
    />
  );
};

export default KeyDisputeCards;